// extracted by mini-css-extract-plugin
module.exports = {"Link":"link_Link__r3_vT","Link__icon":"link_Link__icon__qPOIa"};